interface CommonSearchProps {
  unitIds?: string;
  coworkerFilter?: string[];
  teamsFilter?: string;
  pageIndex?: number;
  pageSize?: number;
}

export const setCommonSearchParams = (
  searchParams: URLSearchParams,
  props: CommonSearchProps
) => {
  if (props.unitIds?.length) {
    searchParams.set("buFilter", props.unitIds);
  }

  if (props.coworkerFilter?.length) {
    searchParams.set("coworkerFilter", props.coworkerFilter.join(","));
  }

  if (props.teamsFilter) {
    searchParams.set("teamsFilter", props.teamsFilter);
  }

  searchParams.set("pageIndex", String(props.pageIndex ?? 0));
  searchParams.set("pageSize", String(props.pageSize ?? 5));
};
